<template>
	<el-table
		:max-height="maxHeight"
		v-bind="$attrs"
		v-horizontal-scroll="'always'"
		v-sticky-header
		:data="list"
		:style="myStyle"
		:class="['table-wrapper', stickyHeader ? 'active-sticky' : 'default-sticky']"
		ref="table"
		:stripe="options.stripe"
		:border="options.border"
		:fit="options.fit"
		:highlight-current-row="options.highlightCurrentRow"
		header-row-class-name="table-header-row"
		row-class-name="table-row"
		:show-header="isShowHeader"
		:row-key="options.rowKey"
		@row-click="rowClick"
		:span-method="spanMethod"
		@selection-change="selectionChange"
		@sort-change="sortChange"
		@cell-mouse-enter="cellMouseEnter"
		@cell-mouse-leave="cellMouseLeave"
		:default-sort="defaultSort"
		:cell-style="$attrs.cellStyle"
	>
		<el-table-column v-if="options.selectable" type="selection" :reserve-selection="$attrs.reserveSelection" :selectable="selectable" width="50">
		</el-table-column>
		<el-table-column v-if="options.hasIndex" type="index" width="50"> </el-table-column>
		<template v-for="(column, index) in columns">
			<el-table-column
				:class-name="column.className"
				:key="column.key + '_' + index"
				:width="column.width"
				:min-width="column.minWidth"
				:fixed="column.fixed"
				:render-header="column.renderHeader"
				:sortable="column.sortable"
				:prop="column.key"
				:resizable="column.resizable"
				:formatter="column.formatter"
				:show-overflow-tooltip="column.showOverflowTooltip"
				:align="column.align || 'center'"
				:label="column.label"
				:header-align="column.headerAlign"
			>
				<template slot="header">
					<span>{{ column.label }}</span>
					<el-tooltip class="item" effect="dark" placement="top">
						<div slot="content">
							<p class="mb-2" v-for="(item, index) in column.helpNum" :key="index">
								{{ column['helpDesc' + item] }}
							</p>
						</div>
						<i class="el-icon-question yx-color-text-placeholder ml-6" v-if="column.helpNum"></i>
					</el-tooltip>
				</template>
				<template slot-scope="{ row }">
					<component
						:column="column"
						:useByTable="true"
						:row="column.transform ? column.transform(row) : row"
						:tabName="tabName"
						:rowIsHover="hoverRowData === row"
						:row-index="index"
						:is="column.type || defaultType"
						@change="changeValue"
					></component>
				</template>
			</el-table-column>
		</template>
		<template slot="empty" v-if="$slots.empty">
			<slot name="empty"></slot>
		</template>
	</el-table>
</template>

<script>
import CellTypes from '@/components/tableCells/index';
export default {
	components: {
		...CellTypes,
	},
	name: 'BaseTable',
	props: {
		columns: {
			type: Array,
			default: () => [],
		},
		list: {
			type: Array,
			default: () => [],
		},
		options: {
			type: Object,
			default: () => {
				return {};
			},
		},
		sortableProp: {
			type: Object,
			default: () => {
				return {};
			},
		},
		rowClick:{
			type: Function,
			default: () => {
				return () => {};
			},
		},
		selectionChange: {
			type: Function,
			default: () => {
				return () => {};
			},
		},
		sortChange: {
			type: Function,
			default: () => {
				return () => {};
			},
		},
		spanMethod: {
			type: Function,
			default: () => {
				return () => {};
			},
		},
		selectable: {
			type: Function,
			default: () => {
				return () => {};
			},
		},
		//暂无数据
		emptyText: {
			type: String,
			default: () => '',
		},
		isShowHeader: {
			type: Boolean,
			default: () => {
				return true;
			},
		},
		tabName: {
			type: String,
			default: () => {
				return '0';
			},
		},
		isAuth: {
			type: Boolean,
			default: false,
		},
		defaultSort: {
			type: Object,
			default: () => {},
		},
		stickyHeader: {
			type: Boolean,
			default: true,
		},
		distanceTop: {
			type: Number,
			default: 65,
		},
		maxHeight: {
			type: [Number, String],
			default: 'auto',
		},
		cellMouseEnter:{
			type: Function,
			default: () => {
				return () => {};
			},
		},
		cellMouseLeave:{
			type: Function,
			default: () => {
				return () => {};
			},
		},
	},
	data() {
		return {
			defaultType: 'TextCell',
			MixinCell: 'MixinCell',
			topScrollWidth: 0,
			hoverRowData: {},
		};
	},
	computed: {
		myStyle({ distanceTop }) {
			return {
				'---distanceTop': distanceTop + 'px',
			};
		},
	},
	methods: {
		changeValue(value) {
			this.$emit('change', value);
		},
		toggleSelection(rows, e) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.table.toggleRowSelection(row, e);
				});
			}
		},
		cellMouseEnterHandle(row, column, cell, event) {
			this.hoverRowData = row;
		},
		cellMouseLeaveHandle(row, column, cell, event) {
			this.hoverRowData = {};
		},
	},
};
</script>

<style lang="less" scoped>
/deep/ .el-table__empty-text {
	line-height: 30px;
}
/deep/ .el-table__fixed {
	box-shadow: 3px 0px 3px rgba(0, 0, 0, 0.08);
}
/deep/ .el-table__fixed-right {
	box-shadow: -3px 0px 3px rgba(0, 0, 0, 0.08);
}
.default-sticky {
	/deep/ .el-table__header-wrapper {
		position: relative !important;
	}
	/deep/ .el-table-horizontal-scrollbar {
		display: none !important;
	}
}
.active-sticky {
	/deep/ .el-table__header-wrapper {
		position: sticky !important;
	}
}
/deep/ .el-table-horizontal-scrollbar {
	bottom: var(---distanceTop) !important;
}
/deep/ .el-table-horizontal-scrollbar {
	display: block !important;
	opacity: 0;
}
.table-wrapper:hover {
	/deep/ .el-table-horizontal-scrollbar {
		opacity: 1 !important;
	}
}
.el-table::before {
	display: none !important;
}
.el-table {
	/deep/ .el-table__fixed::before {
		display: none !important;
	}
	/deep/ .el-table__fixed-right::before {
		display: none !important;
	}
}
// 隐藏滚动条
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
	/*width: 0;宽度为0隐藏*/
	width: 0px;
}

/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
	border-radius: 2px;
	height: 50px;
	background: #eee;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	border-radius: 2px;
	background: rgba(0, 0, 0, 0.4);
}

/deep/ .el-table--scrollable-y .el-table__body-wrapper {
	overflow: hidden !important;
}

/deep/ .el-table--scrollable-x .el-table__body-wrapper {
	overflow: hidden !important;
}
</style>
